import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Modal from '@material-ui/core/Modal';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Paper from '@material-ui/core/Paper';
import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { Menu, MenuItem } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {
	modal: {
		position: 'fixed',
		width: '100%',
		maxWidth: '400px',
		height: '150px',
		top: '20%',
		left: '50%',
		transform: 'translateX(-50%)',
		padding: '20px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		'@media only screen and (max-width: 420px) and (orientation: portrait)': {
			maxWidth: '275px',
		},
	},
	modalButtons: {
		textAlign: 'right',
	},
};

function ActionMenu(props) {
	const { classes, salespersonId, destroySalespersonId, settings, setSalespersonId } = props;
	const [actionMenuAnchor, setActionMenuAnchor] = useState(null);
	const [isSalespersonIdModalOpen, setisSalespersonIdModalOpen] = useState(false);
	const [salespersonIdFieldValue, setSalespersonIdFieldValue] = useState();

	useEffect(() => {
		if (settings.generalSettings.CacheSelectedSalesPersonId) {
			setSalespersonIdFieldValue(salespersonId);
		} else {
			setSalespersonId('');
			destroySalespersonId();
		}
	}, []);

	const handleCloseActionMenu = () => {
		setActionMenuAnchor(null);
	};

	const handleCloseSalespersonIdModal = () => {
		setisSalespersonIdModalOpen(false);
	};

	const handleOpenActionMenu = event => {
		setActionMenuAnchor(event.currentTarget);
	};

	const handleOpenSalespersonIdModal = () => {
		setisSalespersonIdModalOpen(true);
		setActionMenuAnchor(null);
	};

	const handleSalespersonIdFieldChange = event => {
		setSalespersonIdFieldValue(event.target.value);
	};

	const handleSalespersonIdSave = () => {
		const { asyncId, validateSalespersonId } = props;
		const salespersonIdField =
			salespersonIdFieldValue !== undefined ? salespersonIdFieldValue.trim() : '';
		validateSalespersonId(asyncId, salespersonIdField, settings);
		setSalespersonId(salespersonIdField);
		setisSalespersonIdModalOpen(false);
		setSalespersonIdFieldValue(salespersonIdField);
	};

	return (
		<span>
			<IconButton onClick={handleOpenActionMenu}>
				<MoreVertIcon />
			</IconButton>
			<Menu anchorEl={actionMenuAnchor} open={!!actionMenuAnchor} onClose={handleCloseActionMenu}>
				{salespersonIdFieldValue ? (
					<MenuItem disabled>Current ID: {salespersonIdFieldValue}</MenuItem>
				) : null}
				<MenuItem onClick={handleOpenSalespersonIdModal}>Enter Salesperson ID</MenuItem>
			</Menu>

			<Modal open={isSalespersonIdModalOpen} onClose={handleCloseSalespersonIdModal}>
				<Paper className={classes.modal}>
					<TextField
						fullWidth
						label="Salesperson ID"
						onChange={handleSalespersonIdFieldChange}
						value={salespersonIdFieldValue || ''}
					/>
					<div className={classes.modalButtons}>
						<Button onClick={handleSalespersonIdSave}>Save</Button>
						<Button onClick={handleCloseSalespersonIdModal}>Cancel</Button>
					</div>
				</Paper>
			</Modal>
		</span>
	);
}

ActionMenu.propTypes = {
	classes: PropTypes.shape({}).isRequired,
	salespersonId: PropTypes.string,
	setSalespersonId: PropTypes.func.isRequired,
	validateSalespersonId: PropTypes.func.isRequired,
	asyncId: PropTypes.string.isRequired,
	settings: PropTypes.shape({}).isRequired,
	destroySalespersonId: PropTypes.func.isRequired,
};

ActionMenu.defaultProps = {
	salespersonId: undefined,
};

export default withStyles(styles, { name: 'ActionMenu' })(ActionMenu);
